import React, { useCallback, useEffect, useState } from "react";
import {
  createAppRole,
  getCheckRole,
  getRole,
  setCreateAppRole,
  updateAppRole,
} from "../../../../../../redux/AppRole/action";
import { addAppInitialForm, addAppInitialFormError } from "client/Components/Administraton/utils/constant";
import ConfirmationBee from '../../../../../assets/images/Confirmation Bee.svg';
import SuccessBee from '../../../../../assets/images/SuccessBee.svg'
import { useDispatch, useSelector } from "react-redux";
import { popupInitialData } from "utils";
import { commonPopupDisplay } from "client/Components/Administraton/utils/AdministrationUtils";

type Iprops = {
  selectedRole?: any;
  setSelectedKey?: any;
};
const useAddEditRole = (props: Iprops) => {
  const dispatch = useDispatch();
  const { selectedRole, setSelectedKey } = props;

  //Read data from store
  const { appRole, checkRole, isCheck, addedRoleVal, updatedRoleVal,isCheckRole } = useSelector((state: any) => ({
    appRole: state.AppRole.role,
    checkRole: state.AppRole.checkRole,
    isCheck: state.AppRole.isCheck,
    addedRoleVal: state.AppRole.addedRoleVal,
    updatedRoleVal: state.AppRole.updatedRoleVal,
    isCheckRole: state.AppRole.isCheckRole,
  }));
  const [roleFormData, setRoleFormData] = useState<any>(addAppInitialForm);
  const [formError, setFormError] = useState<any>(addAppInitialFormError);
  const [isPermissionSelect, setIsPermissionSelect] = useState(true);
  const [requestBody, setRequestBody] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [selectall, setSelectAll] = useState(false);
  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);
  useEffect(() => {
    if (selectedRole?.roleId) {
      dispatch(getRole(selectedRole.roleId));
    } else {
      dispatch(getRole(0));
    }
    setIsSubmitted(false)
  }, []);

  useEffect(() => {
    setRoleFormData(appRole);
  }, [appRole]);

  const selectAllHandler = (event: any, value: boolean) => {
    setSelectAll(value);
    const updatedPermissions = roleFormData?.permissions?.map((item: any) => ({
      ...item,
      isSelected: value,
    }));
    setRoleFormData({ ...roleFormData, permissions: updatedPermissions });
  };

  const permissionChangeHandler = (rowData: any, value: boolean) => {
    setRoleFormData((prev: any) => {
      const updatedPermissions = prev?.permissions?.map((item: any) => {
        if (item.id === rowData.id) {
          return {
            ...item,
            isSelected: value,
          };
        }
        return item;
      });
      const updatedPermissionCount = updatedPermissions
        .filter((item: any) => item.isSelected)
        .map((item: any) => item.applicationId);
      if (updatedPermissions.length == updatedPermissionCount.length) {
        setSelectAll(true);
      }
      else {
        setSelectAll(false)
      }
      return {
        ...prev,
        permissions: [...updatedPermissions],
      };
    });
  };

  const validation: any = (name: any, value: any, methodType: any) => {
    let error = { ...formError };
    switch (name) {
      case "roleName":
        if (value === undefined || value === "" || value === null) {
          error.roleNameError = "Please enter role name";
        } else {
          error.roleNameError = "";
        }
        break;
      case "roleDescription":
        if (value === undefined || value === "" || value === null) {
          error.roleDescriptionError = "Please enter role description";
        } else {
          error.roleDescriptionError = "";
        }
        break;
      case "applications":
        if (methodType == "add") {
          let text = value?.filter((item: any) => item?.isSelected).map((item: any) => item.applicationId)
          if (text.length == 0) {
            error.applicationsError = "Please select applications";
          } else {
            error.applicationsError = "";
          }
        } else {

          if (value.key === undefined || value.key === "" || value.key === null) {
            error.applicationsError = "Please select applications";
          } else {
            error.applicationsError = "";
          }
        }
        break;
    }
    return error;
  }

  const onChangeHandler = (event: any, value: any) => {
    let name = event.target.getAttribute('name')
    let formValidationError: any = {};
    let formValidation = validation(name, value, "change");
    formValidationError[name + 'Error'] = formValidation[name + 'Error']
    setFormError({ ...formError, [name + 'Error']: formValidation[name + 'Error'] })

    const fieldName = event?.target?.getAttribute("name");
    setRoleFormData({
      ...roleFormData,
      [fieldName]: value,
    });
  };

  const appChangeHandler = (event: any, value: any, fieldName: string) => {
    setSelectAll(false);
    let formValidationError: any = {};
    let formValidation = validation(fieldName, value, "change");
    formValidationError[fieldName + 'Error'] = formValidation[fieldName + 'Error']
    setFormError({ ...formError, [fieldName + 'Error']: formValidation[fieldName + 'Error'] })
    const updatedApps = roleFormData?.applications?.map((app: any) => {
      if (app.applicationId === value.key) {
        return {
          applicationId: value.key,
          applicationName: value.text,
          isSelected: value.selected,
        };
      }
      return app;
    });

    const selectedApps = updatedApps
      .filter((item: any) => item.isSelected)
      .map((item: any) => item.applicationId);
    const filteredPermissions = appRole?.permissions?.filter((permission: any) =>
      selectedApps.includes(permission.applicationID)
    );

    if (filteredPermissions != undefined) {
      setRoleFormData({
        ...roleFormData,
        [fieldName]: [...updatedApps],
        permissions: [...filteredPermissions],
      });
    }
  };

  useEffect(() => {
    if (appRole?.roleId > 0) {
      const selectedApps = appRole?.applications?.filter((item: any) => item.isSelected)
        .map((item: any) => item.applicationId);
      const filteredPermissions = appRole?.permissions?.filter((permission: any) =>
        selectedApps.includes(permission.applicationID)
      );
      const activePermissionCount = filteredPermissions?.filter((item: any) => item.isSelected)
        .map((item: any) => item.applicationId);
      if (filteredPermissions.length == activePermissionCount.length) {
        setSelectAll(true)
      }
      else {
        setSelectAll(false)
      }
      if (filteredPermissions != undefined) {
        setRoleFormData({
          ...roleFormData,
          roleId: appRole?.roleId,
          roleName: appRole?.roleName,
          roleDescription: appRole.roleDescription,
          applications: appRole?.applications,
          permissions: [...filteredPermissions],
        });
      }
    }
  }, [appRole])

  const handleSubmit = () => {
    setIsSubmitted(true)
    const permissions = roleFormData.permissions
      .filter((item: any) => item.isSelected)
      .map((item: any) => item.id);
    const applications = roleFormData.applications
      .filter((item: any) => item.isSelected)
      .map((item: any) => item.applicationId);
    const requestBody = {
      ...roleFormData,
      permissions,
      applications,
    };
    setRequestBody(requestBody);
    let valid = true;
    let formValError: any = {};
    for (let key in roleFormData) {
      let formVal = validation(key, roleFormData[key], "add");
      formValError[key + 'Error'] = formVal[key + 'Error'];
      if (formVal[key + 'Error']) {
        valid = false;
      }
    }

    setFormError({ ...formValError })
    if (valid) {
      if (permissions?.length == 0) {
        setIsPermissionSelect(false)
          let message = "Please select a permission."
          commonPopupDisplay(message, setPopupcontent, Popupcontent, ConfirmationBee, "INFORMATION", handleFailurePopup)
      } else {
        dispatch(getCheckRole(roleFormData))
      }
    }
  };

  useEffect(() => {
    if (!checkRole && isSubmitted && roleFormData?.hasOwnProperty('roleId')) {
      setIsAdding(true)
      setRoleFormData([addAppInitialForm])
      if (selectedRole?.roleId != undefined) {
        dispatch(updateAppRole(requestBody));
      } else {
        dispatch(createAppRole(requestBody));
      }
    }
    else if (checkRole && isSubmitted) {
      let message = "Permission Name given is already exist."
      commonPopupDisplay(message, setPopupcontent, Popupcontent, ConfirmationBee, "INFORMATION", handleFailurePopup)
      setIsSubmitted(false)
    }
  }, [checkRole, isCheck])

  useEffect(() => {
    if ((addedRoleVal != undefined && addedRoleVal != 0 && isSubmitted) || (updatedRoleVal != undefined && updatedRoleVal != 0 && isSubmitted)) {
      if ((addedRoleVal > 0 && !checkRole) || (updatedRoleVal > 0 && !checkRole)) {
        let message: any = "";
        if(appRole?.roleId != 0){
          message = "Role has been updated successfully.";
        }else{
          message = `Role has been created successfully with id ` + addedRoleVal;
        }
        commonPopupDisplay(message, setPopupcontent, Popupcontent, SuccessBee, "SUCCESS", handleClickPopup)
      } else if ((checkRole && (addedRoleVal == 0 || updatedRoleVal == 0) && isCheckRole && isPermissionSelect) || (addedRoleVal == "error" && isPermissionSelect)) {
        let message: any = "";
        if(addedRoleVal == "error"){
          message = "Error Occured while processing the request."
        }else{
          message = "Role Name given is already exist."
        }
        commonPopupDisplay(message, setPopupcontent, Popupcontent, ConfirmationBee, "INFORMATION", handleFailurePopup)
      }
      setIsSubmitted(false)
      setIsAdding(false)
    }
  }, [addedRoleVal, updatedRoleVal, isAdding])

  const handleFailurePopup = () => {
    hideDialog()
    setIsPermissionSelect(true)
    dispatch(setCreateAppRole(0))
  }
  const handleClickPopup = () => {
    hideDialog()
    setSelectedKey("apps-roles")
    setFormError(addAppInitialFormError)
    dispatch(setCreateAppRole(0))
  }

  const getApplications = () => {
    const apps = roleFormData?.applications?.map((item: any) => {
      return {
        key: item.applicationId,
        text: item.applicationName,
        selected: item.isSelected,
      };
    });
    return apps;
  };

  const hideDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    [Popupcontent]
  );

  return {
    selectAllHandler,
    appRole,
    roleFormData,
    onChangeHandler,
    handleSubmit,
    appChangeHandler,
    applications: getApplications(),
    permissionChangeHandler,
    formError,
    isPermissionSelect,
    handleFailurePopup,
    handleClickPopup,
    selectall,
    Popupcontent
  };
};

export default useAddEditRole;
